import { render, staticRenderFns } from "./DoctorSurgery.vue?vue&type=template&id=89f01670&scoped=true"
import script from "./DoctorSurgery.vue?vue&type=script&lang=js"
export * from "./DoctorSurgery.vue?vue&type=script&lang=js"
import style0 from "./DoctorSurgery.vue?vue&type=style&index=0&id=89f01670&prod&scoped=true&lang=css"
import style1 from "./DoctorSurgery.vue?vue&type=style&index=1&id=89f01670&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89f01670",
  null
  
)

export default component.exports